import React from 'react'

const Jva_mat = () => {
    return (
        <div className='container'>
            <h1>Rotate a matrix by 90 degree in clockwise direction without using any extra space</h1>
            <p>Given a square matrix, turn it by 90 degrees in a clockwise direction without using any extra space.</p>
            <p><strong>Examples:</strong>&nbsp;</p>
            <pre className='output'><strong>Input:</strong>  <br />
1 2 3  <br />
4 5 6 <br />
7 8 9   <br />
<strong>Output:</strong> <br />
7 4 1  <br />
8 5 2 <br />
9 6 3 <br />
 <br />
<strong>Input:</strong> <br />
1 2 <br />
3 4 <br />
<strong>Output:</strong> <br />
3 1 <br />
4 2 </pre>
<p><strong>Approach</strong></p>
<p><strong>Approach:</strong> . The only thing that is different is to print the elements of the cycle in a clockwise direction i.e. An N x N matrix will have floor(N/2) square cycles.&nbsp;<br/>
For example, a 3 X 3 matrix will have 1 cycle. The cycle is formed by its 1st row, last column, last row, and 1st column.&nbsp;<br/>
For each square cycle, we swap the elements involved with the corresponding cell in the matrix in the clockwise direction. We just need a temporary variable for this.</p>
<p><strong>Explanation:</strong></p>
<blockquote className='output'>
  <p>Let size of row and column be 3.&nbsp;<br/>
  <strong>During first iteration –</strong>&nbsp;<br/>
  a[i][j] = Element at
    first index (leftmost corner top)= 1.<br/>
    a[j][n-1-i]= Rightmost corner top Element = 3.<br/>
    a[n-1-i][n-1-j] =
    Righmost corner bottom element = 9.<br/>
    a[n-1-j][i] = Leftmost corner bottom element = 7.<br/>
    Move these elements in
    the clockwise direction.&nbsp;<br/>
    <strong>During second iteration –</strong>&nbsp;<br/>
    a[i][j] = 2.<br/>
    a[j][n-1-j] =
    6.<br/>
    a[n-1-i][n-1-j] = 8.<br/>
    a[n-1-j][i] = 4.&nbsp;<br/>
    Similarly, move these elements in the clockwise
    direction.&nbsp;</p>
</blockquote>
<div class="containers">
  <div class="line number1 index0 alt2"><code class="comment">// Java implementation of above approach</code></div>
  <div class="line number2 index1 alt1"><code class="keywords">import</code> <code class="plain">java.io.*;</code></div>
  <div class="line number3 index2 alt2">&nbsp;</div>
  <div class="line number4 index3 alt1"><code class="keywords">class</code> <code class="plain">NooB</code></div>
  <div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
  <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
  <div class="line number7 index6 alt2"><code class="keywords">static</code> <code class="keywords">int</code> <code
      class="plain">N = </code><code class="value">4</code><code class="plain">;</code></div>
  <div class="line number8 index7 alt1">&nbsp;</div>
  <div class="line number9 index8 alt2"><code
      class="comment">// Function to rotate the matrix 90 degree clockwise</code></div>
  <div class="line number10 index9 alt1"><code class="keywords">static</code> <code class="keywords">void</code> <code
      class="plain">rotate90Clockwise(</code><code class="keywords">int</code> <code class="plain">a[][])</code></div>
  <div class="line number11 index10 alt2"><code class="plain">&#123;</code></div>
  <div class="line number12 index11 alt1">&nbsp;</div>
  <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// Traverse each cycle</code></div>
  <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
      class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; N / </code><code
      class="value">2</code><code class="plain">; i++)</code></div>
  <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number16 index15 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">for</code>
    <code class="plain">(</code><code class="keywords">int</code> <code class="plain">j = i; j &lt; N - i - </code><code
      class="value">1</code><code class="plain">; j++)</code></div>
  <div class="line number17 index16 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
  <div class="line number18 index17 alt1">&nbsp;</div>
  <div class="line number19 index18 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// Swap elements of each cycle</code></div>
  <div class="line number20 index19 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="comment">// in clockwise direction</code></div>
  <div class="line number21 index20 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">int</code> <code class="plain">temp = a[i][j];</code></div>
  <div class="line number22 index21 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">a[i][j] = a[N - </code><code class="value">1</code> <code class="plain">- j][i];</code></div>
  <div class="line number23 index22 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">a[N - </code><code class="value">1</code> <code class="plain">- j][i] = a[N - </code><code
      class="value">1</code> <code class="plain">- i][N - </code><code class="value">1</code> <code
      class="plain">- j];</code></div>
  <div class="line number24 index23 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">a[N - </code><code class="value">1</code> <code class="plain">- i][N - </code><code
      class="value">1</code> <code class="plain">- j] = a[j][N - </code><code class="value">1</code> <code
      class="plain">- i];</code></div>
  <div class="line number25 index24 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">a[j][N - </code><code class="value">1</code> <code class="plain">- i] = temp;</code></div>
  <div class="line number26 index25 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
  <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number28 index27 alt1"><code class="plain">&#125;</code></div>
  <div class="line number29 index28 alt2">&nbsp;</div>
  <div class="line number30 index29 alt1"><code class="comment">// Function for print matrix</code></div>
  <div class="line number31 index30 alt2"><code class="keywords">static</code> <code class="keywords">void</code> <code
      class="plain">printMatrix(</code><code class="keywords">int</code> <code class="plain">arr[][])</code></div>
  <div class="line number32 index31 alt1"><code class="plain">&#123;</code></div>
  <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
      class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; N; i++)</code></div>
  <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number35 index34 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">for</code>
    <code class="plain">(</code><code class="keywords">int</code> <code class="plain">j = </code><code
      class="value">0</code><code class="plain">; j &lt; N; j++)</code></div>
  <div class="line number36 index35 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">System.out.print( arr[i][j] + </code><code class="string">" "</code><code class="plain">);</code>
  </div>
  <div class="line number37 index36 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">System.out.println();</code></div>
  <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number39 index38 alt2"><code class="plain">&#125;</code></div>
  <div class="line number40 index39 alt1">&nbsp;</div>
  <div class="line number42 index41 alt1">&nbsp;</div>
  <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
      class="plain">main (String[] args)</code></div>
  <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123;</code></div>
  <div class="line number45 index44 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="keywords">int</code> <code class="plain">arr[][] = &#123; &#123; </code><code class="value">1</code><code
      class="plain">, </code><code class="value">2</code><code class="plain">, </code><code class="value">3</code><code
      class="plain">, </code><code class="value">4</code> <code class="plain">&#125;,</code></div>
  <div class="line number46 index45 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123; </code><code class="value">5</code><code class="plain">, </code><code class="value">6</code><code
      class="plain">, </code><code class="value">7</code><code class="plain">, </code><code class="value">8</code> <code
      class="plain">&#125;,</code></div>
  <div class="line number47 index46 alt2"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123; </code><code class="value">9</code><code class="plain">, </code><code class="value">10</code><code
      class="plain">, </code><code class="value">11</code><code class="plain">, </code><code class="value">12</code>
    <code class="plain">&#125;,</code></div>
  <div class="line number48 index47 alt1"><code
      class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#123; </code><code class="value">13</code><code class="plain">, </code><code
      class="value">14</code><code class="plain">, </code><code class="value">15</code><code
      class="plain">, </code><code class="value">16</code> <code class="plain">&#125; &#125;;</code></div>
  <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">rotate90Clockwise(arr);</code></div>
  <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">printMatrix(arr);</code></div>
  <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
      class="plain">&#125;</code></div>
  <div class="line number52 index51 alt1"><code class="plain">&#125;</code></div>
  <div class="line number53 index52 alt2">&nbsp;</div>

</div>
<div class="output"><strong>Output</strong><pre>13 9 5 1  <br />
14 10 6 2  <br />
15 11 7 3  <br />
16 12 8 4 </pre></div>
        </div>

    )
}

export default Jva_mat
